import { __rest } from 'tslib';
import React__default from 'react';
import { SvgIcon48 } from '../svgIcon48.js';

const ChevronBottom = (_a) => {
    var { fill = '#929292' } = _a, others = __rest(_a, ["fill"]);
    return (React__default.createElement(SvgIcon48, Object.assign({ title: "waiting" }, others),
        React__default.createElement("g", { id: "ICON" },
            React__default.createElement("path", { d: "M26.84,33.59,44.47,16a1.63,1.63,0,0,0,.3-2,1.54,1.54,0,0,0-2.39-.26L25.07,31a1.5,1.5,0,0,1-2.12,0L5.72,13.78a1.63,1.63,0,0,0-2-.3,1.54,1.54,0,0,0-.26,2.39L21.18,33.59A4,4,0,0,0,26.84,33.59Z", fill: fill }))));
};

export { ChevronBottom as default };
